'use client';

import type { schema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import {
  allCssAtom,
  allCssVariablesAtom,
  allJsAtom,
  brandColorAtom,
  copyrightAtom,
  defaultAuthorAtom,
  faviconAtom,
  fontAtom,
  fontSizeAtom,
  footerLinksAtom,
  headerActionsAtom,
  headerLinksAtom,
  langAtom,
  logoAtom,
  quotionBadgeUrlAtom,
  showQuotionBadgeAtom,
  themeAtom,
} from './design-state';

export type HydrateAllAtoms = {
  logo: string;
  favicon: string;
  headerLinks: schema.BlogLink[];
  headerActions?: schema.HeaderActions | null;
  footerLinks: schema.BlogLink[];
  copyright: string;
  showQuotionBadge?: boolean;
  quotionBadgeUrl?: string | null;
  lang?: string;

  theme?: schema.ThemeType | null;
  font?: string | null;
  fontSize?: number | null;
  brandColor?: string | null;
  defaultAuthor?: schema.DefaultAuthor | null;
  cssVariables?: schema.AllCssVariables | null;
  customCss?: string | null;
  customJs?: string | null;
};

export function HydrateAllAtoms(props: HydrateAllAtoms) {
  const store = useStore();
  useHydrateAtoms(
    // @ts-expect-error - fix types
    [
      [logoAtom, props.logo],
      [faviconAtom, props.favicon],
      [headerLinksAtom, props.headerLinks],
      props.headerActions && [headerActionsAtom, props.headerActions],
      [footerLinksAtom, props.footerLinks],
      [copyrightAtom, props.copyright],
      typeof props.showQuotionBadge === 'boolean' && [
        showQuotionBadgeAtom,
        props.showQuotionBadge,
      ],
      props.quotionBadgeUrl && [quotionBadgeUrlAtom, props.quotionBadgeUrl],

      props.defaultAuthor && [defaultAuthorAtom, props.defaultAuthor],
      props.lang && [langAtom, props.lang],
      props.theme && [themeAtom, props.theme],
      props.font && [fontAtom, props.font],
      props.fontSize && [fontSizeAtom, props.fontSize],
      props.brandColor && [brandColorAtom, props.brandColor],
      props.cssVariables && [allCssVariablesAtom, props.cssVariables],
      props.customCss && [allCssAtom, props.customCss],
      props.customJs && [allJsAtom, props.customJs],
    ].filter(Boolean),
    {
      store,
    },
  );

  return <></>;
}
